import { createContext, FC, useContext, useReducer } from 'react'
import { Student } from '../interfaces/ModuleTypes'

type StudentContextState = {
    currentStudent: Student | null
}

const initialState: StudentContextState = {
    currentStudent: null,
}

enum StudentActionType {
    SET_CURRENT_STUDENT
}

type StudentAction =
    {
        type: StudentActionType.SET_CURRENT_STUDENT
        payload: Student | null
    }

const studentReducer = (state: StudentContextState, action: StudentAction) => {
    switch (action.type) {
        case StudentActionType.SET_CURRENT_STUDENT:
            return { ...state, currentStudent: action.payload } as StudentContextState
        default:
            return state
    }
}

const StudentContext = createContext<{
    studentState: StudentContextState
    studentDispatch: (action: StudentAction) => void
}>({ studentState: initialState, studentDispatch: () => null })

const StudentContextProvider: FC<{ children: any }> = ({ children }: { children: any }) => {
    const [state, dispatch] = useReducer(studentReducer, initialState)
    const contextValue = { studentState: state, studentDispatch: dispatch }
    return (
        <StudentContext.Provider value={contextValue}>
            {children}
        </StudentContext.Provider>
    )
}

const useStudentContext = () => {
    const context = useContext(StudentContext)
    if (!context) {
        throw new Error(
            'useStudentContext must be used within a StudentContextProvider. Wrap a parent component in <StudentContextProvider> to fix this error.'
        )
    }

    const { studentState: { currentStudent }, studentDispatch } = context

    const setCurrentStudent = (student: Student | null) => {
        studentDispatch({
            type: StudentActionType.SET_CURRENT_STUDENT,
            payload: student,
        })
    }
    return { currentStudent, setCurrentStudent }
}
export default useStudentContext
export { StudentContextProvider }
